
import { NavLink } from "react-router-dom";
import {
  Dashboard, Logout,
} from "@mui/icons-material";
import menuConfig from "../../../config/MenuConfig";


const Sidebar = ({ collapsed, onLogout, user }) => {
  return (
    <aside className={`bg-white shadow-md h-full flex flex-col transition-all duration-300 ${collapsed ? "w-16" : "w-64"}`}>
      {/* Top Header */}
      <div className="p-4 text-xl font-bold flex items-center justify-center gap-2 border-b" style={{ fontFamily: "Greycliff CF" }}>
        <Dashboard className="text-[#449AEF]" />
        {!collapsed && "ADMIN"}
      </div>

      {/* Menu Items */}
      <div className="flex-1 overflow-y-auto">
        <nav className="flex flex-col p-2">
          {menuConfig
            .filter(item => item.category === "Admin")
            .map(({ name, path, icon: Icon }) => (
              <NavLink
                key={path}
                to={path}
                end
                className={({ isActive }) =>
                  `flex items-center p-1 mt-1 mb-1 rounded no-underline 
                  hover:bg-[#449AEF] hover:text-white 
                  ${isActive ? "bg-[#449AEF] font-bold text-white" : ""}`
                }
                style={{ textDecoration: "none", fontFamily: "Greycliff CF" }}
              >
                <Icon className="h-5 w-5 me-2" />
                {!collapsed && <>{name}</>}
              </NavLink>
            ))}
        </nav>
      </div>


      {/* Bottom User Section */}
      <div className="p-1 border-t mb-1">
        {!collapsed ? (
          <div className="flex items-center justify-between w-full">
            {/* Left side - Avatar + Name + Email */}
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-full bg-[#449AEF] text-white flex items-center justify-center text-md font-bold uppercase">
                {user?.name?.charAt(0) || "A"}
              </div>
              <div>
                <div className="font-medium truncate max-w-[120px]">{user?.name || "Admin"}</div>
                <div className="text-gray-500 text-sm truncate max-w-[160px]">
                  {user?.email || "Admin@gmail.com"}
                </div>
              </div>
            </div>

            {/* Right side - Logout Button */}
            <button
              onClick={onLogout}
              className="p-1 rounded-full hover:bg-gray-100 transition-colors"
              title="Logout"
            >
              <Logout className="text-gray-700 hover:text-[#449AEF]" />
            </button>
          </div>
        ) : (
          <div className="flex justify-center">
            <button
              onClick={onLogout}
              className="p-1 rounded-full hover:bg-gray-100 transition-colors"
              title="Logout"
            >
              <Logout className="text-gray-700 hover:text-[#449AEF]" />
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
